import React from 'react';
import '../App.css';
import broImage from '../images/bro.jpeg';
import Faqs from './Faqs';

const AlgoHeadsBlog = () => {
  return (
    <div className="blog-container">
      <header className="blog-header">
        <h1>AlgoHeads: Automating Your Referral Network</h1>
        <div className="blog-meta">
          
          <div className="blog-author-container">
            <a href="https://www.linkedin.com/in/ligade24/" target="_blank" rel="noopener noreferrer" className="author-image-link">
              <img src={broImage} alt="Author" className="author-image" />
            </a>
            <span className="blog-author">By <a href="https://www.linkedin.com/in/ligade24/" target="_blank" rel="noopener noreferrer">Sourabh Ligade</a></span>
          </div>
        </div>
      </header>

      <main className="blog-content">
        <section>
          <p className="lead-paragraph">
            Job hunting is hard. Referrals make it easier. But tracking down which of your connections work where jobs are open is tedious and time-consuming. AlgoHeads solves this problem by automatically connecting your professional network to active job openings.
          </p>
        </section>

        <section>
          <h2>The Problem</h2>
          <p>
            Most job seekers approach networking backwards. They find interesting jobs first, then manually search through their connections to see if they know someone at that company. This process is:
          </p>
          <ul>
            <li>Time-consuming (scrolling through hundreds of connections)</li>
            <li>Inefficient (easy to miss connections)</li>
            <li>Demotivating (feels like starting from zero with each application)</li>
          </ul>
          <p className="quote">
            "I felt like I was sitting on a gold mine of job referrals but couldn't effectively tap into it."
          </p>
        </section>

        <section>
          <h2>The Solution: AlgoHeads</h2>
          <p>
            AlgoHeads flips the traditional job search process. Instead of finding jobs and then searching for connections, AlgoHeads automatically shows you jobs where you already have connections.
          </p>
          
          <h3>How AlgoHeads Works:</h3>
          <ol>
            <li>Upload your LinkedIn connections (a simple CSV file)</li>
            <li>Our system processes your network data</li>
            <li>We scan job sites for openings at companies where your connections work</li>
            <li>You instantly see job openings matched with your existing connections</li>
          </ol>

          <h3>Key Features:</h3>
          <ul>
            <li><strong>Connection-First Job Matching:</strong> See only jobs where you have inside connections</li>
            <li><strong>Multi-Source Job Scanning:</strong> Pulls openings from LinkedIn, Indeed, Glassdoor, and more</li>
            <li><strong>Location-Based Filtering:</strong> Focus on jobs in your preferred locations</li>
            <li><strong>Searchable Database:</strong> Filter by job title, company, or location</li>
            <li><strong>Direct Application Links:</strong> Apply easily with just one click</li>
          </ul>
        </section>

        <section>
          <h2>The Impact</h2>
          <p>
            Using AlgoHeads transforms your job search from:
          </p>
          
          <div className="comparison-text">
            <div>
              <h4>Old Way:</h4>
              <ol>
                <li>Find job</li>
                <li>Search your network</li>
                <li>Maybe find a connection</li>
                <li>Reach out for referral</li>
              </ol>
            </div>
            <div>
              <h4>AlgoHeads Way:</h4>
              <ol>
                <li>See job opening + matching connection instantly</li>
                <li>Reach out for referral</li>
              </ol>
            </div>
          </div>
          
          <p>
            Users report spending 70% less time on their job search while increasing their application-to-interview ratio by 3x.
          </p>
          <p className="quote">
            "It's like having a personal matchmaker that knows both where my connections work AND where the openings are."
          </p>
        </section>

        <section>
          <h2>How AlgoHeads Works Under the Hood</h2>
          <ol>
            <li>Users upload their LinkedIn connections data (CSV file) which contains their professional network information including company names and positions.</li>
            <li>The system processes these connections, extracting company information and storing them in a database with optimized indexes for quick retrieval.</li>
            <li>For each company in the user's network, the system automatically scrapes job postings from multiple job boards (LinkedIn, Indeed, Glassdoor, etc.) based on the user's location preferences.</li>
            <li>The system matches these job postings with the user's connections, showing which connections work at companies with open positions.</li>
            <li>Users can filter and search through these job listings by title, company, location, and see how many of their connections work at each company.</li>
            <li>The system provides direct job application links and shows connection details to help users leverage their network for potential referrals.</li>
          </ol>
        </section>

        {/* FAQ Section */}
        <section className="blog-faqs">
          <Faqs />
        </section>
      </main>
    </div>
  );
};

export default AlgoHeadsBlog;